var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { LicenseState } from "@/app/store/modules/license.state";
import { CompaniesClient, LookupsClient, CompanyEditionModel, UpdateCompanyEditionCommand, HostingOptionEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { DateHelper } from "@/app/utils/date-helper";
const companiesClient = new CompaniesClient(window.apiUrl);
const lookupsClient = new LookupsClient(window.apiUrl);
// All edition options matching AssureEditionEnum
const AllEditionOptions = [
    { value: 0, text: "On-Prem Basic" },
    { value: 1, text: "On-Prem Standard" },
    { value: 2, text: "On-Prem Premium" },
    { value: 100, text: "Powershield Cloud Standard" }
];
// Mapping from HostingOptionEnum to allowed editions (matches backend HostingOptionToAllowedEditions)
const HostingOptionToAllowedEditions = {
    [HostingOptionEnum.OnPrem]: [0, 1, 2], // OnPremBasic, OnPremStandard, OnPremPremium
    [HostingOptionEnum.PowershieldCloud]: [100] // PowershieldCloudStandard
};
let CompanyEditionVue = class CompanyEditionVue extends Vue {
    constructor() {
        super(...arguments);
        this.companyEdition = {
            companyId: 0,
            editionId: 0,
            dueDate: null
        };
        this.lookupsLoaded = false;
        this.saving = false;
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig(false);
    }
    mounted() {
        this.loadCompanyEdition();
    }
    onCompanyIdChange() {
        if (this.lookupsLoaded) {
            this.loadCompanyEdition();
        }
    }
    loadCompanyEdition() {
        if (!this.companyId) {
            return;
        }
        companiesClient.getEdition(this.companyId)
            .then((response) => {
            this.mapCompanyEdition(response);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                // Edition may not exist yet, initialize with defaults
                this.companyEdition = {
                    companyId: this.companyId,
                    editionId: 0,
                    dueDate: null,
                };
            });
        });
    }
    mapCompanyEdition(response) {
        this.companyEdition = {
            companyId: response.companyId,
            editionId: response.editionId,
            dueDate: response.dueDate ? new Date(response.dueDate.toString()) : null
        };
    }
    getCompanyEdition() {
        const model = new CompanyEditionModel();
        model.companyId = this.companyId;
        model.editionId = this.companyEdition.editionId;
        model.dueDate = this.companyEdition.dueDate ? new Date(this.companyEdition.dueDate) : new Date();
        return model;
    }
    save() {
        this.saving = true;
        const model = this.getCompanyEdition();
        const command = new UpdateCompanyEditionCommand();
        command.requestModel = model;
        companiesClient.updateEdition(this.companyId, command)
            .then(() => {
            Notifier.onOk("Edition saved successfully.");
            this.loadCompanyEdition();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.saving = false;
        });
    }
    get selectedEdition() {
        return this.allowedEditionOptions.find(e => e.value === this.companyEdition.editionId) || null;
    }
    set selectedEdition(item) {
        var _a;
        this.companyEdition.editionId = (_a = item === null || item === void 0 ? void 0 : item.value) !== null && _a !== void 0 ? _a : 0;
    }
    get allowedEditionOptions() {
        const hostingOption = this.licenseState.hostingOption;
        const allowedEditionIds = HostingOptionToAllowedEditions[hostingOption] || [];
        return AllEditionOptions.filter(e => allowedEditionIds.includes(e.value));
    }
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], CompanyEditionVue.prototype, "loginState", void 0);
__decorate([
    State("licenseModule"),
    __metadata("design:type", typeof (_b = typeof LicenseState !== "undefined" && LicenseState) === "function" ? _b : Object)
], CompanyEditionVue.prototype, "licenseState", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], CompanyEditionVue.prototype, "companyId", void 0);
__decorate([
    Watch("companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanyEditionVue.prototype, "onCompanyIdChange", null);
CompanyEditionVue = __decorate([
    Component({
        name: "CompanyEditionVue",
        expose: ["getCompanyEdition", "save"]
    })
], CompanyEditionVue);
export default CompanyEditionVue;
